/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */ 
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  
  production: true,
  
    //apiUrl: window["apiUrl"] || 'http://192.168.0.107:8081/', //#DEF001053 #senthil #19-sept-2019  local
    //apiUrl: window["apiUrl"] || 'http://192.168.0.110:8081/',
    // apiUrl: window["apiUrl"] || 'http://192.168.0.162:8080/',

    //   apiUrl: window["apiUrl"] || 'http://3.6.189.154:8080/', //#DEF001053 #senthil #19-sept-2019
    // // // // // // // // apiUrl: window["apiUrl"] || 'http://192.168.0.175:8080/',
    // // // // // // // // angularUrl: window["angularUrl"] || 'http://192.168.0.175:4200/',
    // // // // // // // // // // // //angularUrl: window["angularUrl"] || 'http://192.168.0.112:4200/', //#DEF001053 #senthil #19-sept-2019
    //  angularUrl: window["angularUrl"] || 'http://3.6.189.154/', //#DEF001053 #senthil #19-sept-2019
    // pythonUrl: 'http://192.168.68.101:5000/',
    // pythonUrl: 'http://3.6.189.154/',

     // https://sertfy.tqdemo.in/
   apiUrl: window["apiUrl"] || 'https://sertfy.tqdemo.in/api/',
   angularUrl: 'https://sertfy.tqdemo.in/',
   pythonUrl: 'https://sertfy.tqdemo.in/',

    //localhost\ lp-31 or 02*
  // apiUrl: window["apiUrl"] || 'http://localhost:8083/',
  // angularUrl: window["angularUrl"] || 'localhost:4200/',
  // pythonUrl: 'http://localhost:5000/',

  //chartrequest
  // apiUrl: window["apiUrl"] || 'http://172.31.19.121:8080/',
  //   pythonUrl: 'http://172.31.19.121/',
  //   angularUrl: window["angularUrl"] || 'http://172.31.19.121:4200/',

  // apiUrl: window["apiUrl"] || 'https://automation.chartrequest.com/api/',
  //    angularUrl: 'https://automation.chartrequest.com/',
  //    pythonUrl: 'https://automation.chartrequest.com/'

  // apiUrl: window["apiUrl"] || 'http://192.168.68.102:8080/',
  // pythonUrl: 'http://192.168.68.102:5000/',
  
  // apiUrl: window["apiUrl"] || 'http://3.6.189.154:8080/',
  // angularUrl: window["angularUrl"] || 'http://3.6.189.154/',
  // pythonUrl: 'http://3.6.189.154/',
  
  // apiUrl: window["apiUrl"] || ' http://localhost:8083/',
  // angularUrl: window["angularUrl"] || 'localhost:4200/',
  // apiUrl: window["apiUrl"] || 'http://192.168.68.102:8080/', //JAVA
  // // angularUrl: window["angularUrl"] || 'http:3.6.189.154:4200/', 
  // pythonUrl: 'http://192.168.68.102:5000/', //PYTHON
  // pythonUrl: 'http://localhost:5000/',

};